import UserIcon from '@heroicons/react/20/solid/UserIcon';
import { P } from 'components/Text';
import { SearchQueryParams } from 'containers/SearchField';
import { useTranslation } from 'next-i18next/pages';
import { useCallback } from 'react';
import { parsePassengerNumInQuery } from 'utils/utils';

interface TicketProps {
  query?: Partial<SearchQueryParams>;
  isRoundTrip: boolean;
  numOfPassengers?: number;
  className?: string;
}

const Ticket: React.FC<TicketProps> = ({
  query,
  isRoundTrip,
  numOfPassengers,
  className,
}) => {
  const { t } = useTranslation();
  const passengerCount = useCallback(() => {
    return (
      parsePassengerNumInQuery(query?.adults, true) +
      parsePassengerNumInQuery(query?.children) +
      parsePassengerNumInQuery(query?.infants)
    );
  }, [query]);
  return (
    <div className={`flex ${className} space-x-1`}>
      <UserIcon className="h-4 w-4 text-tt-dark-purple" />
      <P>
        {query ? passengerCount() : numOfPassengers} •{' '}
        {isRoundTrip ? t('Round-trip') : t('One-way')}
      </P>
    </div>
  );
};

export default Ticket;
